import { BigNumber } from "bignumber.js";

// 0x1_0000_0000_0000_0000
const OFFSET = new BigNumber("10000000000000000", 16);
// 0x7fff_ffff_ffff_ffff
const MAX = new BigNumber("7fffffffffffffff", 16);
const ZERO = new BigNumber("0");
const WIDTH = 16; // 16桁で固定

/**
 * 符号有り64bit整数値のBigNumberの値を符号無し64bit整数値の16進数表記の文字列にして返す
 * @param {BigNumber} value BigNumberのインスタンス
 * @return {String} 16桁固定小文字小文字、0xというプレフィクスを含む文字列
 */
export function fromBigNumber(v: BigNumber | string | number) {
  if (v === undefined || v === null || typeof v === "string") {
    return v;
  }
  if (typeof v === "number" && Math.floor(v) !== v) {
    return v.toString();
  }
  const value = typeof v === "number" ? new BigNumber(v) : v;
  const uint = value.comparedTo(ZERO) === -1 ? value.plus(OFFSET) : value;
  const str = uint.toString(16);
  const padding = "0".repeat(WIDTH - str.length);
  return `0x${padding}${str}`;
}

/**
 * 符号無し64bit整数値の16進数表記の文字列を符号有り64bit整数のBigNumberにして返す
 * @param {String} 16桁固定小文字小文字、0xというプレフィクスを含む文字列
 * @return {BigNumber} BigNumberのインスタンス
 */
export function toBigNumber(value: BigNumber | string): BigNumber {
  if (typeof value !== "string") {
    return value;
  }
  const uint = new BigNumber(value.replace(/^0x/, ""), 16);
  return uint.comparedTo(MAX) === 1 ? uint.minus(OFFSET) : uint;
}
